/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Directive } from '@angular/core';
import { LoggerService } from '@shared/services/logger.service';
import { HotKeyService } from './hot-key.service';

@Directive({
    host: {
        '(window:keydown)': 'onKeyDown($event)',
    },
    selector: '[csHotKeys]',
    standalone: true
})
export class HotKeysDirective {
    constructor(private hotKeyService: HotKeyService) {}

    onKeyDown(evt: KeyboardEvent) {
        const tagName = (evt.target as HTMLElement).tagName;
        if ('input' !== tagName.toLowerCase() && 'textarea' !== tagName.toLowerCase()) {
            const code = evt.key;
            if (code && !(evt.ctrlKey || evt.altKey)) {
                const val = evt.shiftKey ? code : code.toLowerCase();
                if ('' !== val) {
                    this.hotKeyService.trigger(val);
                    evt.stopPropagation();
                }
            }
        }
    }
}
